import { MOVE_TO_NEW_SLOT } from 'services/context/assessmentContext/assessmentContext';
import { updateSectionToSubmitted } from 'services/requests/sectionRequests';

export const moveToNextSlot = (
  slotIndex,
  sectionIndex,
  assessment,
  dispatch,
  submitSection
) => {
  const {
    uuid,
    assessment: { slug },
    section_attempts
  } = assessment;
  const currentSection = section_attempts[sectionIndex];
  const {
    slot_attempts,
    section: { is_linear }
  } = currentSection;
  let endSection;

  if (is_linear) {
    endSection =
      slotIndex === slot_attempts[slot_attempts.length - 1].sort_index ||
      submitSection;
  } else {
    endSection = submitSection;
  }

  if (endSection) {
    dispatch({
      type: MOVE_TO_NEW_SLOT,
      payload: {
        assessment,
        currentSlotId: null,
        currentSectionIndex: null,
        slotIsLoading: true
      }
    });

    updateSectionToSubmitted(
      assessment,
      slug,
      uuid,
      currentSection.id,
      sectionIndex,
      dispatch
    );
  } else {
    const index = is_linear ? slotIndex + 1 : slotIndex;
    // NOTE: currentSlotIndex carries a sort_index (see useSetCurrentSlot), but
    // it is used positionally here. The two drift apart if sort_index is ever
    // non-contiguous, which is one way index lands out of range.
    const nextSlot = slot_attempts[index];

    if (!nextSlot) {
      // The answer POST already succeeded, so staying put is correct: never
      // eject the taker to an error page over a bad navigation target.
      console.error('moveToNextSlot: slot index out of range', {
        index,
        slotIndex,
        is_linear,
        slotCount: slot_attempts.length
      });
      return;
    }

    dispatch({
      type: MOVE_TO_NEW_SLOT,
      payload: {
        assessment,
        currentSlotId: nextSlot.id,
        currentSlotIndex: index,
        slotIsLoading: false
      }
    });
  }
};
